import { BlankEditorDoTest } from '@doltech/ui/lib/figma/BlankEditor/DoTest/BlankEditorDoTest';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { QuestionV2 } from '@doltech/ui/lib/figma/Question/QuestionV2';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestSentenceCompleteQuestionInstance } from '../student-do-test/model/Question/do-test-sentence-complete-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import { SingleAnswerMain } from './SingleAnswer';

export interface SentenceCompleteProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestSentenceCompleteQuestionInstance;
}

const Main = styled(SingleAnswerMain)`
  background-color: ${colorsV2.white100};
  border-radius: 16px;
  box-shadow: 0 2px 2px ${colorsV2.blackShadow5};
  padding: 16px;

  display: grid;
  gap: 12px;

  margin-top: 16px;
`;

const QuestionWrapper = styled.div`
  display: flex;
  .question-no {
    display: inline-block;
  }
`;

export const SentenceComplete = observer((props: SentenceCompleteProps) => {
  const {
    data: { no, getUserAnswers, sentences, onAnswerQuestion, setSentence },

    ...rest
  } = props;
  const userAnswers = getUserAnswers();
  const store = useTestSubmissionStore();
  return (
    <Main className="dol-question single-answer" {...rest}>
      {sentences.map((sentence, index) => {
        return (
          <QuestionWrapper key={sentence.id}>
            <QuestionV2 no={no + index} />
            <BlankEditorDoTest
              editorValue={sentence.editorValueJS}
              no={no}
              blanks={sentence.blanks as any[]}
              blankValues={userAnswers}
              onBlankChange={(input) => {
                if (store.preventUserAction()) return;
                onAnswerQuestion(input);
              }}
              onEditorChange={(editorChange) =>
                setSentence({ id: sentence.id, value: editorChange })
              }
              showQuestionNo={false}
              withToolBar
            />
          </QuestionWrapper>
        );
      })}
    </Main>
  );
});
